export default [
  {
    name: '6-8-patterns-video-1',
    sources: [
      'https://player.vimeo.com/external/414363054.m3u8?s=71c0ac8e665e2caebf0417d3dc45a95c8cb0bdaa&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414363054.sd.mp4?s=301794eafa98c4e36e90696cc31b3a897071d024&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: '6-8-patterns-video-2',
    sources: [
      'https://player.vimeo.com/external/414369185.m3u8?s=85a9d08eeb2e78228adf5f901268823a5b9035f6&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414369185.sd.mp4?s=b0926d10ff0e1277cdec821d4d02bc069004b863&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: '6-8-patterns-video-3',
    sources: [
      'https://player.vimeo.com/external/414369212.m3u8?s=57e3de0ae59887511edd6b91aaf455d04e8118ba&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414369212.sd.mp4?s=f212c648470b5ba696eb1a08d6ac5201270cd2f7&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: '6-8-patterns-video-4',
    sources: [
      'https://player.vimeo.com/external/414369237.m3u8?s=0fea0c07d4ec76cc872b4e074f83123409fa6e7a&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414369237.sd.mp4?s=72bf1e94fabfe1d5f4c0bf63a78eda0900b8b594&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: '6-8-patterns-video-5',
    sources: [
      'https://player.vimeo.com/external/414369263.m3u8?s=d01f607b5ba33d91405a1f0a3f421a11f5b29f8b&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414369263.sd.mp4?s=f052b7ea57f01e502dfdee978bf55bdd2c3b7ad4&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: '6-8-patterns-video-6',
    sources: [
      'https://player.vimeo.com/external/414369294.m3u8?s=57202ec17d76a2bb49b4925d3eec14c759652cb4&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414369294.sd.mp4?s=6de53df463227007b17d28772e82564c702d7f9c&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: '6-8-patterns-video-7',
    sources: [
      'https://player.vimeo.com/external/414369328.m3u8?s=ea38981b3c14a32263d7259b529c3862c97c1d97&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414369328.sd.mp4?s=1e4e3cd04a596434e18f2a7d77c012237c607d58&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'accidentals1-1',
    sources: [
      'https://player.vimeo.com/external/414369359.m3u8?s=6c8d76fe59ab661390f00f7ecc4ff67316ef4837&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414369359.sd.mp4?s=40ef9646b1f9ab88af387a17ec55313d0c1d9463&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'accidentals1-2',
    sources: [
      'https://player.vimeo.com/external/414369379.m3u8?s=912a12cef284ef675d9016ea739f24fdbd254341&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414369379.sd.mp4?s=a20facd17d93f1ff2f21ceb63ea1e8d35f8cdf63&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'accidentals1-3',
    sources: [
      'https://player.vimeo.com/external/414369412.m3u8?s=a4aeee05513c57a287ee44ae81f591e711a07b6f&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414369412.sd.mp4?s=0cd94bf07f38f028b380bc1be856dd0103a80def&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'accidentals1-3a',
    sources: [
      'https://player.vimeo.com/external/414369446.m3u8?s=8c580dbd864cfd933a7ff40eaca9fa5ac16fdbc6&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414369446.sd.mp4?s=f62ee9682e4d63c4363acfa7196f77cbdc7458b5&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'accidentals1-4',
    sources: [
      'https://player.vimeo.com/external/414369462.m3u8?s=d3ebdf15e168c57cb734e2dd92d0df8e9c1e2825&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414369462.sd.mp4?s=bae54572af449b507cb31b5eec3fb14ee7d401b1&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'accidentals2-1',
    sources: [
      'https://player.vimeo.com/external/414369491.m3u8?s=49845002bbc029defc176f7df07fd97f9c53beb1&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414369491.sd.mp4?s=bcd609895f4e160074ed45d29f1c61698030490b&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'accidentals2-2',
    sources: [
      'https://player.vimeo.com/external/414369523.m3u8?s=f0515fa9b8566c2c88eff2678d2c7f2233640419&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414369523.sd.mp4?s=f1043d477192476eabb4bb58495e0fcaa95349bc&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'accidentals2-3',
    sources: [
      'https://player.vimeo.com/external/414369546.m3u8?s=ad041895e12782f854d541e9412f6d4e4d9d0f0f&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414369546.sd.mp4?s=ec4a1f239541f5a3a9c56aba214fc10cdafbff65&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'accidentals2-4',
    sources: [
      'https://player.vimeo.com/external/414369570.m3u8?s=0648397f1dd67231fab571bffa243adb6ab4da37&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414369570.sd.mp4?s=648cca6bef6b2fc05245343068731c1c3ad437d2&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'ascendingIntervals1',
    sources: [
      'https://player.vimeo.com/external/414369595.m3u8?s=3f96b2076cfbe3a330e28e6819896c14d462c0b9&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414369595.sd.mp4?s=3302619dc33fa3fff2bf8b0c82cf76a45283121a&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'ascendingIntervals2',
    sources: [
      'https://player.vimeo.com/external/414369632.m3u8?s=53cf8208d3ab251684d00e40ae694df69432b71e&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414369632.sd.mp4?s=a0390802c6385b985faf4533ac8cfe84bafe7f61&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'ascendingIntervals3',
    sources: [
      'https://player.vimeo.com/external/414369665.m3u8?s=3dac8d9d643e4f5fbf795e9df9d5d83ac00770a9&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414369665.sd.mp4?s=e14a15084b3bb4b7f51c3140d22bd33582602f06&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'ascendingIntervals4',
    sources: [
      'https://player.vimeo.com/external/414369703.m3u8?s=460c8348dfebd3746d459d2df1ed14499dab1a18&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414369703.sd.mp4?s=615d53daa367e42608f7baa90d2c763adb37889d&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'ascendingIntervals5',
    sources: [
      'https://player.vimeo.com/external/414369731.m3u8?s=b50e046ba0f2c64e866d35c293ca186c3e553eeb&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414369731.sd.mp4?s=e747ed22f361dc44f2a19c1d1ffab8928af65068&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'ascendingIntervals6',
    sources: [
      'https://player.vimeo.com/external/414369758.m3u8?s=113a0082ed130c7cdf66fed2de443063761c8fea&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414369758.sd.mp4?s=3f0426d7d23dd05bf73e8900a52a093fa0476c1f&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'ascendingIntervals7',
    sources: [
      'https://player.vimeo.com/external/414369788.m3u8?s=0a7cf66a40991d2554f01ea43c263809003fa81c&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414369788.sd.mp4?s=5a06e2996c80a86a240655d6545f77bd043299df&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'bassClef1-1',
    sources: [
      'https://player.vimeo.com/external/414369817.m3u8?s=231e1351a9f249c3fc060268a828da74b2a65803&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414369817.sd.mp4?s=f5599a3cc788a4e5eee24ab0e7e13b2d47c663cf&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'bassClef1-2',
    sources: [
      'https://player.vimeo.com/external/414369840.m3u8?s=4c809cc1865d7f9f75ec3a8e431b178677231b8d&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414369840.sd.mp4?s=beaa80ecfd5d8f3b84bda2810f2f0196154eafef&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'bassClef1-3',
    sources: [
      'https://player.vimeo.com/external/414369876.m3u8?s=41603b96f73dc94818fcfe81b672c42866f1150f&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414369876.sd.mp4?s=f64674bde5a2d4c31bc6c66f4f576f7171d3a49e&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'bassClef1-4',
    sources: [
      'https://player.vimeo.com/external/414369907.m3u8?s=7dd1eea42d116250bf7808942d7eb3479222025e&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414369907.sd.mp4?s=57bec380bf691f6ce78509de3320e7fb5d5e4c00&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'bassClef1-5',
    sources: [
      'https://player.vimeo.com/external/414369941.m3u8?s=98f8274fbea74809aa6920bb8538904b8a028b71&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414369941.sd.mp4?s=f70c9e1c228b474fbe5b3d6b0dbc328024523343&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'bassClef2-1',
    sources: [
      // 'https://player.vimeo.com/external/862151334.m3u8?s=b1d27eb67c16f1284728b51e43721d49493f93ef&logging=false',
      // 'https://player.vimeo.com/progressive_redirect/playback/862151334/rendition/720p/file.mp4?loc=external&signature=e3da1dfc679858dea0c0a2d544c29d4b8162b4ab8f6944e5ca674a2fba41155c',
      // 'https://player.vimeo.com/progressive_redirect/download/862151334/rendition/720p/bassclef2-1a%20%28720p%29.mp4?loc=external&signature=c38d9b342281cf7eb947618ffa7431bc2a9c85ea057a161ab0d18ffd3a042e94'
      'https://player.vimeo.com/external/414369969.m3u8?s=1efc84681828811df6d129793fc090410c50d707&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414369969.sd.mp4?s=1bd19bf8256700e3496ca64ad908cddc957211fc&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'bassClef2-2',
    sources: [
      'https://player.vimeo.com/external/414370000.m3u8?s=8e5cb8dee5a9bef2a4aac83d75f8cbbd961878fe&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370000.sd.mp4?s=3016219b7380339d2c98ce0174f89566e41ff2a3&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'beatsQuartersEighths1american',
    sources: [
      'https://player.vimeo.com/external/414370021.m3u8?s=3329890c1c0c5e6a72b87732b6cacfcecad1d104&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370021.sd.mp4?s=1987cc4f4a08d882b203c5862c74f2d2c4b67fa1&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'beatsQuartersEighths2american',
    sources: [
      'https://player.vimeo.com/external/414370051.m3u8?s=34721c51ef50b450c45375beb7f238c6e3ade89c&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370051.sd.mp4?s=654686725f574c668fc39d18b60e07acc8c932c6&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'beatsQuartersEighths3american',
    sources: [
      'https://player.vimeo.com/external/414370079.m3u8?s=046107846a66f9cf354503a27b260cebcc737116&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370079.sd.mp4?s=0f6e9e21304080f5541a2ac00e91124d1d255214&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'beatsQuartersEighths4american',
    sources: [
      'https://player.vimeo.com/external/414370107.m3u8?s=ce4d08a2c37e94b526cf76d3409415cf0009eef0&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370107.sd.mp4?s=2fa4367dacbe40614804b1dc3749094b56c8345f&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'beatsQuartersEighths5american',
    sources: [
      'https://player.vimeo.com/external/414370130.m3u8?s=5c3ce09c1b5d346cb1efc2775a73a8c66869e8ab&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370130.sd.mp4?s=daed35767bdd4d3517718cc27d0d151f70e20b2e&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'compoundMeters1american',
    sources: [
      'https://player.vimeo.com/external/414370156.m3u8?s=e561a4ade297271886b9ab38bf17050465270a9a&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370156.sd.mp4?s=87968eb52c891777ffba3fcae354bc85cd97c9aa&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'compoundMeters2american',
    sources: [
      'https://player.vimeo.com/external/414370181.m3u8?s=d6cffdf3e47034fd1048325e1a8e40891df792d1&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370181.sd.mp4?s=25e02f7e244c50873e683c05a0b1c12f9bd0975f&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'compoundMeters3american',
    sources: [
      'https://player.vimeo.com/external/414370203.m3u8?s=6efb4fc4c183e48b2770d088be5b566ec0372749&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370203.sd.mp4?s=4474e8f1b602bdcd9a493fa43d75bd360345b7c1&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'compoundMeters4american',
    sources: [
      'https://player.vimeo.com/external/414370235.m3u8?s=a274d5852ef5815134694bceadb00840b1f8c21e&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370235.sd.mp4?s=efeffbbcaff10058eea6f681f6b41fe834b8c981&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'compoundMeters5american',
    sources: [
      'https://player.vimeo.com/external/414370261.m3u8?s=5d1b72ba070a69f360f7adf325b1de1313be8f18&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370261.sd.mp4?s=21af8b4c41e911492d75c7d75c47204e8a3025fc&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'compoundMeters6american',
    sources: [
      'https://player.vimeo.com/external/414370288.m3u8?s=c995df7f840aaef034d9f3d4df18e8976766760c&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370288.sd.mp4?s=4838fdbaa0a67d8eed74fe8082f7545415d1464c&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'descendingIntervals1',
    sources: [
      'https://player.vimeo.com/external/414370310.m3u8?s=a2948f5300b06e020a6da06ce30572d7147e1f53&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370310.sd.mp4?s=a7fcd1de60400a7c02d61c08aa305e8c1d401ff8&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'descendingIntervals2',
    sources: [
      'https://player.vimeo.com/external/414370342.m3u8?s=ac6fbc6b20d410217355dfb08e906dd351d8d976&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370342.sd.mp4?s=0c61b73ed87b47f5912570c54d7fa8aff5087ce1&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'descendingIntervals3',
    sources: [
      'https://player.vimeo.com/external/414370366.m3u8?s=effc2a4cbbd35711176f7eacc4a96fa9d7a2bd25&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370366.sd.mp4?s=7fbb8dec7d2531e558c04efd974972f01a0a1f40&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'descendingIntervals4',
    sources: [
      'https://player.vimeo.com/external/414370400.m3u8?s=efe48d37a24d8f9e29ab5ddb359597462fc1bd29&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370400.sd.mp4?s=2e70e48470c0cf9b842388dc2856af7557e23a9a&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'descendingIntervals5',
    sources: [
      'https://player.vimeo.com/external/414370424.m3u8?s=8d347a5b5bba3136acfd153399bd6af7f229cb76&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370424.sd.mp4?s=0a741285bbaff684473e94c34272c5c522f67e09&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'descendingIntervals6',
    sources: [
      'https://player.vimeo.com/external/414370451.m3u8?s=8ca8528e8120f1ae451c2ceb4fa5447ffa7c058d&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370451.sd.mp4?s=dc81e3838b103a0ce860b7d1854821c4ba667603&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'dottedNotesAndOffbeats1american',
    sources: [
      'https://player.vimeo.com/external/414370472.m3u8?s=1b7d9b76c3e39753294855590da2d86373d3e29f&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370472.sd.mp4?s=fc213e8d5d448cff80ef113f3168c5a1e99202b5&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'dottedNotesAndOffbeats2american',
    sources: [
      'https://player.vimeo.com/external/414370498.m3u8?s=fa3bf77adc80b249073f4ae8d934f0f5b0837c50&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370498.sd.mp4?s=cb4c6e9a994cd67315ad21caadd7f6cae2137f17&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'dottedNotesAndOffbeats3american',
    sources: [
      'https://player.vimeo.com/external/414370531.m3u8?s=5180b08c1f83acbc9b8a55d83f6ab0a1f49ab141&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370531.sd.mp4?s=c727ae74dc5676983423e7cc90b42a54dab82fc0&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'dottedNotesAndOffbeats4american',
    sources: [
      'https://player.vimeo.com/external/414370556.m3u8?s=4eb44b0255601cc34ad8413fa2dba8a22f5a4aaf&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370556.sd.mp4?s=c9976cf0b16863d5c7362f7463db0241e7ae3db2&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'dottedNotesAndOffbeats5american',
    sources: [
      'https://player.vimeo.com/external/414370580.m3u8?s=e9ca772484414f4bf91f646aea66caba0cb79b6f&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370580.sd.mp4?s=01a2cf3c6d65cb12a1fe8f0c814e53e8117fe818&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'dottedNotesAndOffbeats6american',
    sources: [
      'https://player.vimeo.com/external/414370616.m3u8?s=606d3721ec5225e0710a72f6a2cf82d408585e63&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370616.sd.mp4?s=3b8549969ee8850e5b62aa3519bac44f46e032ec&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'dottedNotesAndOffbeats7american',
    sources: [
      'https://player.vimeo.com/external/414370643.m3u8?s=880029513608755e19f6e132385affc3affffd27&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370643.sd.mp4?s=1babd18e9e736cc6a57980962407ec529fa38b77&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'flatMajorKeys1',
    sources: [
      'https://player.vimeo.com/external/414370668.m3u8?s=cd3389410da149da6801c3a12c890e814c8b7a7c&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370668.sd.mp4?s=634f2805e111d82eadcee1c2a1730af8ae8aca78&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'flatMajorKeys2',
    sources: [
      'https://player.vimeo.com/external/414370687.m3u8?s=7b867ab7f0e0f932826f9f90ccdeeede90b332c8&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370687.sd.mp4?s=cfe613564c5b590bd08c13c39e61f505280fb212&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'flatMajorKeys3',
    sources: [
      'https://player.vimeo.com/external/414370719.m3u8?s=c8fb7baa281289585c4dee0860c12b11813688cb&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370719.sd.mp4?s=875bdb5369d23508e78c96a4c8026a82c4129974&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'flatMajorKeys4',
    sources: [
      'https://player.vimeo.com/external/414370752.m3u8?s=08b66c86e9eee232cb35bb3519d7f363945b2cd1&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370752.sd.mp4?s=d7ef9db542bf3f9840e5a07d606a6718de6c076b&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'flatMajorKeys5',
    sources: [
      'https://player.vimeo.com/external/414370783.m3u8?s=8fcc2d3f77746c812a143e23d79262a0f094cd0f&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370783.sd.mp4?s=de9a6c90210060b93d4eaf135fa50d0e36f9e23c&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'flatMajorKeys6',
    sources: [
      'https://player.vimeo.com/external/414370811.m3u8?s=b4246dab3b20957fe55d05eabbc6cd99d39c2e4f&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370811.sd.mp4?s=9bd61763a95318487e00bd9ef75ed3872be1a9a9&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'flatMajorKeys7',
    sources: [
      'https://player.vimeo.com/external/414370844.m3u8?s=a6aee05c2341e313ce395426df45b348db0802b6&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370844.sd.mp4?s=43fb97b17262051bfc1e0cd6bb264333e4060a36&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'flatMajorKeys8',
    sources: [
      'https://player.vimeo.com/external/414370878.m3u8?s=4d6090102b0a0698d0b3e7cbf4fb073ee4279361&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370878.sd.mp4?s=26fcc5b33572aa9b9bb6e19d7c80bbc522c90e17&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'genericIntervals1',
    sources: [
      'https://player.vimeo.com/external/414370904.m3u8?s=edd84687114932a14fad7e8c245580ad145f7593&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370904.sd.mp4?s=e3c1b33056c87af16a6cfc82be1b047f086a03de&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'genericIntervals2',
    sources: [
      'https://player.vimeo.com/external/414370934.m3u8?s=46f2b3db58868970774c3e69fbed63cdde57df79&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370934.sd.mp4?s=1c06eddded23c3c2263c9373a79fda425cae8b33&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'genericIntervals3',
    sources: [
      'https://player.vimeo.com/external/414370967.m3u8?s=6dab34e3b90c24e4262004c003a053e98835249b&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370967.sd.mp4?s=d30f0c9cbdc9287172cfe9b98c7c06e9d45e0d9a&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'genericIntervals4',
    sources: [
      'https://player.vimeo.com/external/414370999.m3u8?s=4eb9ae94838ffe072f14968c91f2285807e6c192&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414370999.sd.mp4?s=af7c42ca84bd20b7c8f2b6c2236580f6245859f3&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'halfWholePiano1',
    sources: [
      'https://player.vimeo.com/external/414371041.m3u8?s=475bbbfbe63d0f1c9231f24ff30e3750b2c94e5c&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414371041.sd.mp4?s=1d8b73523515891c8404e94f4d0061869033a019&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'halfWholePiano2',
    sources: [
      'https://player.vimeo.com/external/414371073.m3u8?s=6849175a14b1a696df4aaa2908057f2da2b6ba42&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414371073.sd.mp4?s=31f43daea5da0259a4e9532300de74b0c1212494&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'halfWholePiano3',
    sources: [
      'https://player.vimeo.com/external/414371106.m3u8?s=6cd3f0e3a721da6e63ad96f9e6028a82eafbab8c&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414371106.sd.mp4?s=284be9e036850685fd905f744940115381e78138&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'halvesWholes1',
    sources: [
      'https://player.vimeo.com/external/414371133.m3u8?s=125f3a971669e376394e5faa6fc7220b339e2616&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414371133.sd.mp4?s=a81f60ad3d994dc379d3c19def6dcb9264b6f0dd&profile_id=139&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'halvesWholes2',
    sources: [
      'https://player.vimeo.com/external/414371163.m3u8?s=5859386baa673beacfd7be990661597f3a84818a&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414371163.sd.mp4?s=bcd09f64b8f6b0c994e954ca32b2015b88ee4d07&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'halvesWholes3',
    sources: [
      'https://player.vimeo.com/external/414371194.m3u8?s=73df55b1e69586080bb810307d3ecb290f9a82ee&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414371194.sd.mp4?s=dfccbf4f79e4d96dd8fc55fbd66f9553e34fa430&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'halvesWholes4',
    sources: [
      'https://player.vimeo.com/external/414371231.m3u8?s=a5aa46a98a24d4a405ae1127893c02d7aca90e72&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414371231.sd.mp4?s=27164e7392e9bb6ff30bd960c727de6dadac4ed2&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'halvesWholes5',
    sources: [
      'https://player.vimeo.com/external/414371255.m3u8?s=dbaa4fb00ff92c48b2030665ce13cff9d3062977&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414371255.sd.mp4?s=d332f4332992881be4c75a41cd217c84e7429892&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'harmonicMinorScales1',
    sources: [
      'https://player.vimeo.com/external/414371287.m3u8?s=f7c3679e636dbcb01a5d518bb9f6f8c2ed2e4a35&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414371287.sd.mp4?s=a1361567b05a38c3759ecd8fc00a2bc72b5302e3&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'harmonicMinorScales2',
    sources: [
      'https://player.vimeo.com/external/414371325.m3u8?s=d8d2069c010cdfbb2e722416103dc41a3340d8ad&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414371325.sd.mp4?s=5fe47d9f9c5d772d93c65851425b02b8da35f038&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'harmonicMinorScales3',
    sources: [
      'https://player.vimeo.com/external/414371358.m3u8?s=ee832b13bfc99aef53132ad23ab101409961abd1&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414371358.sd.mp4?s=1c6c56b6ca1bcf90e9db7af81def456f29cc1688&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'harmonicMinorScales4',
    sources: [
      'https://player.vimeo.com/external/414371391.m3u8?s=272038560c5befc0c8afb30d469cd20cf22d2017&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414371391.sd.mp4?s=47a98cc22115296a93b09d2903197173f7b45e13&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'harmonicMinorScales5',
    sources: [
      'https://player.vimeo.com/external/414371422.m3u8?s=e778e946e719a3329d2cad714163950432801886&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414371422.sd.mp4?s=8c7cb0fb97744565cf4f0954720c12557457c6bd&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'intervalInversion1',
    sources: [
      'https://player.vimeo.com/external/414371462.m3u8?s=908ee6197d8c8ba7626bacf4cbb8366b597a8f0e&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414371462.sd.mp4?s=a5a90c256b1711babaf807de57239409bd5cd6e5&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'intervalInversion2',
    sources: [
      'https://player.vimeo.com/external/414371490.m3u8?s=c376f85512203fcc9ed3e716e7997c9e1a15af18&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414371490.sd.mp4?s=1bbb93d8bea7602fa3db9ce0c45bb72e5ec000b6&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'intervalInversion3',
    sources: [
      'https://player.vimeo.com/external/414371515.m3u8?s=bdf8b31c2cab81e697691b5abe358b45deef2ce0&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414371515.sd.mp4?s=e05f69d0756327d7965ef4e3b5fafb47f4143dc5&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'intervalInversion4',
    sources: [
      'https://player.vimeo.com/external/414371550.m3u8?s=6fb13751598b9edb19306a9ee7e463f035ce9922&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414371550.sd.mp4?s=93737dc625215528c8b3fdb7ecd26b8fa3a7adf4&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'majorScalesPiano1',
    sources: [
      'https://player.vimeo.com/external/414371588.m3u8?s=d259ded0eb6e34d4cda435260f89e9153e2fa889&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414371588.sd.mp4?s=c1d25d3f99e24a37d3a36750eb5e8e2d220ea2e1&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'majorScalesPiano2',
    sources: [
      'https://player.vimeo.com/external/414371619.m3u8?s=3c6bc9787e683490ebffb6d492c6e5f3dadd254b&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414371619.sd.mp4?s=21ad904a8045aef51521196a5b58b8f7144db2e0&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'majorScalesPiano3',
    sources: [
      'https://player.vimeo.com/external/414371656.m3u8?s=35602ca8fa94f9f13c7d893715c9495abd3bb75f&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414371656.sd.mp4?s=84874a85070149001c8ce403d2cad8d3c8a183c5&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'majorScalesPiano4',
    sources: [
      'https://player.vimeo.com/external/414371685.m3u8?s=c3a6a2f0fc9d7b9baa02e010b713736e1b429167&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414371685.sd.mp4?s=a6d0a6ca23892b2dc2c5870bfe5e9f9b47fe40de&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'majorScalesPiano5',
    sources: [
      'https://player.vimeo.com/external/414371718.m3u8?s=44a0627d5992cfb09c1e8c082108097a5c4ad015&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414371718.sd.mp4?s=b036c8367f580773c6e73967be1d3e7ef2a18c59&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'melodicDirection1',
    sources: [
      'https://player.vimeo.com/external/414371755.m3u8?s=d7a0ded06a24d472c7e9708a00d408a2862a0ad7&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414371755.sd.mp4?s=643a5b2725b5ae2f10fd8d1d2e41d7df631e4692&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'melodicDirection2',
    sources: [
      'https://player.vimeo.com/external/414371786.m3u8?s=8d62ecdd33a24743bfef30a4819703b267cc0bd2&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414371786.sd.mp4?s=3cc065220002512c2d7236cb4d56576655b01a12&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'melodicDirection3',
    sources: [
      'https://player.vimeo.com/external/414371818.m3u8?s=ab47129bb0c4ce19e17466ac288b53b2fc6812b8&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414371818.sd.mp4?s=ec6128f87ea00bc69512c1136ae98fa8b8b28b46&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'melodicDirection4',
    sources: [
      'https://player.vimeo.com/external/414371863.m3u8?s=311d29de41140bc797b1f11bcc574bc4ea97d573&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414371863.sd.mp4?s=8e50bbe3b20861b822154fb40f2740b61496e229&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'melodicDirection5',
    sources: [
      'https://player.vimeo.com/external/414371894.m3u8?s=4ae7ae3bc2f9766037d7a43a93326ec4caa03d2e&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414371894.sd.mp4?s=16cc025c3ce25189c37da5d7cc68628e4220244e&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'melodicDirection6',
    sources: [
      'https://player.vimeo.com/external/414371924.m3u8?s=b83e0bd6f694e4a10ff270b32b616f1808a17ee0&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414371924.sd.mp4?s=186ff6aa2a7c7dd36a7a65d4616e158e654085cc&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'melodicMinorScales1',
    sources: [
      'https://player.vimeo.com/external/414371955.m3u8?s=ced30218745d1378242b0db90fb0767558176e67&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414371955.sd.mp4?s=dea95da4c288ec4412e1a6c340dc2290bbd95724&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'melodicMinorScales2',
    sources: [
      'https://player.vimeo.com/external/414371987.m3u8?s=a30982056b9ddd56dc9148b9181354875b1b397e&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414371987.sd.mp4?s=c5729ba26b146d1c66237abc393a8fd0bf941a2d&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'melodicMinorScales3',
    sources: [
      'https://player.vimeo.com/external/414372026.m3u8?s=2e27601eead0bfb0d17f9eefab965f68e18eabb3&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414372026.sd.mp4?s=5aa2d9e80b1344674542afc6fe4c80967649d300&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'melodicMinorScales4',
    sources: [
      'https://player.vimeo.com/external/414372063.m3u8?s=8535bac7221701896eebe3cdb075f586d719ff94&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414372063.sd.mp4?s=7c1e0c2ace6f396ccc54de7c1499d024e5cc6038&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'melodicMinorScales5',
    sources: [
      'https://player.vimeo.com/external/414372090.m3u8?s=4168012e0b3aa6c6cac568e694924c8fb0f0d7d3&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414372090.sd.mp4?s=77c30a2e2fad4069c9615bd0903517707dc811b4&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'minorKeySigs1',
    sources: [
      'https://player.vimeo.com/external/414372125.m3u8?s=02385a6984151b8fa34017cfe1ea6da5933bbd95&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414372125.sd.mp4?s=8504bf8130e89202cdcfebf571a13d1e248696ec&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'minorKeySigs2',
    sources: [
      'https://player.vimeo.com/external/414372154.m3u8?s=e53d07090283486f55451fe4a3b8ab6586f5e7dd&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414372154.sd.mp4?s=44590b2cbc0f634d11848debee21fb77cb7e5646&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'minorKeySigs3',
    sources: [
      'https://player.vimeo.com/external/414372181.m3u8?s=3d2315928824a7ee73cbbbdb76015886b488635e&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414372181.sd.mp4?s=ec69932fb2ee08b3ee3ee08f9151734016161c6a&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'minorKeySigs4',
    sources: [
      'https://player.vimeo.com/external/414372204.m3u8?s=6e0d972f9b0295863df09d00320eeca0e7b351b4&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414372204.sd.mp4?s=dd516fd989e04388658451f699a24de52d278095&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'minorKeySigs5',
    sources: [
      'https://player.vimeo.com/external/414372230.m3u8?s=ebf51271c73fadbcb7c57ed8de8a3cbdfd51c062&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414372230.sd.mp4?s=c6e6d2c6cfaa7fd7cc3e329f094f4963b787ecf7&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'minorKeySigs6',
    sources: [
      'https://player.vimeo.com/external/414372256.m3u8?s=7d782fb65acd0accd091517152a203ae40c2e450&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414372256.sd.mp4?s=4f54048e2bba40b3eb4ebe1f5fb8e50cd922eb03&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'minorKeySigs7',
    sources: [
      'https://player.vimeo.com/external/414372286.m3u8?s=8f388c63721067a2ec638d4c6512cd2de7bdf62f&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414372286.sd.mp4?s=617b8db47845072aee3ed6b0682451a7ad5811c1&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'minorKeySigs8',
    sources: [
      'https://player.vimeo.com/external/414372313.m3u8?s=055376afd8c05eac2fbf8b561cbd41b01ca067ed&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414372313.sd.mp4?s=2d0d5215a245228a5900f8abf1a01e1507632d93&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'naturalMinorScales1',
    sources: [
      'https://player.vimeo.com/external/414372338.m3u8?s=25869e8eb106802935a7297945cfed70e25b21ed&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414372338.sd.mp4?s=14474cb69f7254dbe32bef0ef6e15fadc1c8dd79&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'naturalMinorScales2',
    sources: [
      'https://player.vimeo.com/external/414372362.m3u8?s=765d266db34eb9eb9df1047a372b159a83eb7353&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414372362.sd.mp4?s=838ee207be4da75de249d336d0a610213a7f3af8&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'naturalMinorScales3',
    sources: [
      'https://player.vimeo.com/external/414372394.m3u8?s=5b5280f7a9a616144a62f59d732f067bd7c5bfb4&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414372394.sd.mp4?s=b47b4f2ff56912b2297ca008639e0b60b4f88dc3&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'naturalMinorScales4',
    sources: [
      'https://player.vimeo.com/external/414372421.m3u8?s=19f30d07815ac8eb5d2aca2e488d9574aafb3d56&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414372421.sd.mp4?s=e46a12d1857570819dd76ec3012e6235f112ac32&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'naturalMinorScales5',
    sources: [
      'https://player.vimeo.com/external/414372452.m3u8?s=3d89d6c3e90bdc2197d658b61e2ed8f644fad350&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414372452.sd.mp4?s=116443a39f51eb2b5a5c957b87738749410b8f86&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'pianoWhiteNotes1',
    sources: [
      'https://player.vimeo.com/external/414372484.m3u8?s=d7f00117ecbe3d2c85bfee68f8522ceeddc90816&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414372484.sd.mp4?s=69bafad082a478f6a8bc69a54434085f4ea019e9&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'pianoWhiteNotes2',
    sources: [
      'https://player.vimeo.com/external/414372517.m3u8?s=40621f1f3bfe6bfc54d6f205e1d8ec161007d685&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414372517.sd.mp4?s=5a0a6594e4c303e4f0a2eecc3948e1dc4c5085e5&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'pianoWhiteNotes3',
    sources: [
      'https://player.vimeo.com/external/414372551.m3u8?s=0e9da797b12638b74978d70d414a03d63f12437b&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414372551.sd.mp4?s=a982dbedf88eeca8f6e49cc1683f3b5af706cfaa&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'pianoWhiteNotes4',
    sources: [
      'https://player.vimeo.com/external/414372577.m3u8?s=d231ffa5d205785fdc8316909a94d2f461de8fa2&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414372577.sd.mp4?s=0a64d527bcc081698a50aabe66c8eb815191348b&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'pianoWhiteNotes5',
    sources: [
      'https://player.vimeo.com/external/414372598.m3u8?s=d991696246681e158c1adb78adf57148c94dc2ac&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414372598.sd.mp4?s=fa3139d1187eaa1d7ec3d139c249c6e276e792bb&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'pianoWhiteNotes6',
    sources: [
      'https://player.vimeo.com/external/414372626.m3u8?s=49a3f13ae1c1418fa00dc0b222212d37ec263697&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414372626.sd.mp4?s=dc57b49e7d5c61bef0670747a326608ccc567fef&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'romanNumeralsInMajor10',
    sources: [
      'https://player.vimeo.com/external/414372664.m3u8?s=560c6f181accc5a8802eae6aa8d3339658a965a2&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414372664.sd.mp4?s=6bef6cba0ab49fa03697f74138bfa72eb058c2f2&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'romanNumeralsInMajor1',
    sources: [
      'https://player.vimeo.com/external/414372684.m3u8?s=cc61f16b30955ed77e6092987d66d88f0d144f11&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414372684.sd.mp4?s=9e9d7b304a8b66c32034946bef507e7df77fc6a3&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'romanNumeralsInMajor2',
    sources: [
      'https://player.vimeo.com/external/414372711.m3u8?s=538daafe0c87a37678ff1922102f3ad0f78ca0ea&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414372711.sd.mp4?s=f1e54f4c8b73c72414f6cdff983b761c580401b6&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'romanNumeralsInMajor3',
    sources: [
      'https://player.vimeo.com/external/414372738.m3u8?s=06a8c33e1dde4fb4daba19bb24d09ed1dae28d4a&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414372738.sd.mp4?s=ef149240579d720ce593874d455c5343d197a843&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'romanNumeralsInMajor4',
    sources: [
      'https://player.vimeo.com/external/414372766.m3u8?s=07b394ee02407aad5fd06398a8d8af708abeb4c7&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414372766.sd.mp4?s=e8fbeeeaaa4181abf116e9cb5b2603ecd67c1d80&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'romanNumeralsInMajor5',
    sources: [
      'https://player.vimeo.com/external/414372796.m3u8?s=45b508a29a97ef57e76547f9e7235c64a6653785&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414372796.sd.mp4?s=573fd2aab6bf5d6e9b10b28b4de6da287bfcb8d2&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'romanNumeralsInMajor6',
    sources: [
      'https://player.vimeo.com/external/414372840.m3u8?s=4c0f1b7f6939d3c2268d210135e9585dabdc02c2&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414372840.sd.mp4?s=8067dc32d2018697435c0e52830a56d54f21d59a&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'romanNumeralsInMajor7',
    sources: [
      'https://player.vimeo.com/external/414372868.m3u8?s=f9ec8644b3bd8083aee91cf67d048e448f56efb2&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414372868.sd.mp4?s=d3266edd1dd560102f6f939e60fb244a02ed3241&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'romanNumeralsInMajor8',
    sources: [
      'https://player.vimeo.com/external/414372896.m3u8?s=1c768bcdd0c8e0c58e3554b1a9af800094e4fa3b&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414372896.sd.mp4?s=f0e6d06e4d3de02e90a98eab4f4714d2918f6e55&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'romanNumeralsInMajor9',
    sources: [
      'https://player.vimeo.com/external/414372923.m3u8?s=61d8df968fd5f702a771dadac303dd68023dae10&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414372923.sd.mp4?s=4ad86753a57afcd6b1389be1a7429e43ca9ffd59&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'romanNumeralsInMinor1',
    sources: [
      'https://player.vimeo.com/external/414372953.m3u8?s=474af1c25e6258bbdc941eb8d5753da529d03178&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414372953.sd.mp4?s=e31b6c0b00027783db0005fa56e8d8f6edc9535c&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'romanNumeralsInMinor2',
    sources: [
      'https://player.vimeo.com/external/414372985.m3u8?s=26db5305712374cee935bb42957ccc3094c4649a&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414372985.sd.mp4?s=45b1374f60cd02b105d7632d6fe4cc15e41878f0&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'romanNumeralsInMinor3',
    sources: [
      'https://player.vimeo.com/external/414373008.m3u8?s=7849edb46e18c383123d08ab67e9483dca3ae149&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414373008.sd.mp4?s=79087309e9ada8d05c0c781b12bf578df66af69d&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'romanNumeralsInMinor4',
    sources: [
      'https://player.vimeo.com/external/414373026.m3u8?s=9230cbce594697d3e4491d07ef83a7d1ac1b4572&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414373026.sd.mp4?s=544174ecb5f97ce8ead6c2415a4023ef153a938e&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'romanNumeralsInMinor5',
    sources: [
      'https://player.vimeo.com/external/414373054.m3u8?s=ea18c858b09aabc7c8322b7bbc9163ef15aa69c6&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414373054.sd.mp4?s=4169bc9e220c411003d627ed28da7bdabe84dc67&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'romanNumeralsInMinor6',
    sources: [
      'https://player.vimeo.com/external/414373086.m3u8?s=c0c23b090e1f9536daf81960a0f0dd7567cbdcc7&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414373086.sd.mp4?s=9a029516b4e612cfba356c1ed779ca24f587fbfe&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'romanNumeralsInMinor7',
    sources: [
      'https://player.vimeo.com/external/414373116.m3u8?s=3c7b249ef88589dc9fea52b6b2cbeae54b06fdd9&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414373116.sd.mp4?s=acd5e241eb2d2de13ea6cef1445434abb220e75c&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'romanNumeralsInMinor8',
    sources: [
      'https://player.vimeo.com/external/414373143.m3u8?s=1b0820b3eaf1626c2e8ea949f91c737e5aa7c561&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414373143.sd.mp4?s=2081c119b1a4d60f2f25bf9f9b2264deaf8406a3&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'scaleDegrees1',
    sources: [
      'https://player.vimeo.com/external/414373164.m3u8?s=886f85d648a363d27d38fe9619e8c01e2c094fa4&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414373164.sd.mp4?s=3790ea8981c98bcb97296f60495b8819f0fa0dd1&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'scaleDegrees2',
    sources: [
      'https://player.vimeo.com/external/414373191.m3u8?s=8663ba9ecfbe7a2c7cb32a5266ca120a7911318b&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414373191.sd.mp4?s=14810897d7e216c7a5e76d083958bafd506a2459&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'scaleDegrees3',
    sources: [
      'https://player.vimeo.com/external/414373226.m3u8?s=74115b2906684fe0fbeb6572d4c143054fd7afea&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414373226.sd.mp4?s=a14d0a68e9f6e4aeff403c45571dd3b8ea8ae787&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'scaleDegrees4',
    sources: [
      'https://player.vimeo.com/external/414373248.m3u8?s=4d69f634121cd015016b6d23c1dd303d12efe12f&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414373248.sd.mp4?s=6ca30b546111802ca2565f2c52fa93729c554ee5&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'scaleDegrees5',
    sources: [
      'https://player.vimeo.com/external/414373280.m3u8?s=6becc9e251158f34b7e7086159582a108fdc2338&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414373280.sd.mp4?s=af83bfb92af9faec82051c2ed27e2538018a33c1&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'scaleDegrees6',
    sources: [
      'https://player.vimeo.com/external/414373304.m3u8?s=0159511b5395d550c1fdd1ee713fd698d0674316&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414373304.sd.mp4?s=edb98c81cb2ceb52e26a5c9efd4ce0195c8920ab&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'sd123video1',
    sources: [
      'https://player.vimeo.com/external/414373330.m3u8?s=772ab68f013bb2eca62d39db77c9633196fbc2b6&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414373330.sd.mp4?s=578ca4d5bdc03a01b893612df559cc12b53fa8fa&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'sd123video2',
    sources: [
      'https://player.vimeo.com/external/414597295.m3u8?s=844741472f9cd2971f493ae2ad5632d1746e72d3',
      'https://player.vimeo.com/external/414597295.sd.mp4?s=abfd3ba8ac1701f8754387aa62937eafe73a0e8d&profile_id=164',
    ],
  },
  {
    name: 'sd123video4',
    sources: [
      'https://player.vimeo.com/external/414373389.m3u8?s=ba0a35710c8137af095fb8e8c601777e0ad24db4&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414373389.sd.mp4?s=c3f23cff053d1cbf32bcebb8666ac03a0091fc12&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'sd123video5',
    sources: [
      'https://player.vimeo.com/external/414373412.m3u8?s=29fa87d5548c63c701ac2ef7a54a81dd2838ae11&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414373412.sd.mp4?s=3602680093f74b8a833ce39702f67d1689b16fe4&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'sd123video6scaleDegrees',
    sources: [
      'https://player.vimeo.com/external/414373448.m3u8?s=6170a94f1c9894fae8cf802f477294212211dece&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414373448.sd.mp4?s=24749e76dd95191ff794a9c099e2ccc6b550c7bc&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'sd123video6solfege',
    sources: [
      'https://player.vimeo.com/external/414373477.m3u8?s=dec79d72c4c8716890982c0db70a4c2b4331d822&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414373477.sd.mp4?s=6a972f714ecc3a62f995cbfcbbf2e7ab804010c3&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'sd123video7scaleDegrees',
    sources: [
      'https://player.vimeo.com/external/414373505.m3u8?s=7d1bcbf81836fb7fba2ba58fc447a5af3f757549&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414373505.sd.mp4?s=15e469bd67ced1babdcf0652fe39e328c6c49db1&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'sd123video7solfege',
    sources: [
      'https://player.vimeo.com/external/414373540.m3u8?s=b72570c38c769673ee5f17edd9c3952169436b64&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414373540.sd.mp4?s=1b664dc19c2a33fde7a3c7a0b1ab82ed21be899e&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'sd123video8',
    sources: [
      'https://player.vimeo.com/external/414373571.m3u8?s=3bac92b2c4321d2270d0c587baee6ac13841f0c3&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414373571.sd.mp4?s=bcaa877f23945d9f4397ccc15fc5e05107f87639&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'seventhChord4',
    sources: [
      'https://player.vimeo.com/external/414373596.m3u8?s=dd01aecf59009d7ac1a6d99db46737d5ed6e6efa&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414373596.sd.mp4?s=a31f1efa9461386123e606a97854b3d70237fe66&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'seventhChords1',
    sources: [
      'https://player.vimeo.com/external/414373623.m3u8?s=0e073e45544cdfea4d68f7c39e80131aeab622c3&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414373623.sd.mp4?s=e59629c3641779019096d6ff1bc285075141d5a2&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'seventhChords2',
    sources: [
      'https://player.vimeo.com/external/414373666.m3u8?s=40d61097fcc331e09113ac828907908a1be69dcc&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414373666.sd.mp4?s=7eae9c47c8174c0624ec70788cda201c0b2c03fe&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'seventhChords3',
    sources: [
      'https://player.vimeo.com/external/414373696.m3u8?s=eac2401844c30d0b6df6a3be670ab70541f6bee5&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414373696.sd.mp4?s=5c7a84852b743671f819d55821a45dd3a138bdd1&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'seventhChords4',
    sources: [
      'https://player.vimeo.com/external/414373718.m3u8?s=027f2589c73e90cbd743535a11c7d095ae7ac91c&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414373718.sd.mp4?s=d5decaaf9f3b21b5bc5ed56abf81f322a5522e7a&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'seventhChords5',
    sources: [
      'https://player.vimeo.com/external/414373743.m3u8?s=dbf14e49f27d954fcaf1f43e46b4c32b6108d42f&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414373743.sd.mp4?s=2dfc8dc12126e2772fda31678d902018c2b35d45&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'seventhChords6',
    sources: [
      'https://player.vimeo.com/external/414373775.m3u8?s=ad04fdd981f94f0c87c66df3ebe0416203f5f73c&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414373775.sd.mp4?s=e1d0c2a24fae3261ac9d95e57b87d326838ebea0&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'seventhChords7',
    sources: [
      'https://player.vimeo.com/external/414373809.m3u8?s=3907ff0a6643c0fcac54b51dc11e526befb0ca36&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414373809.sd.mp4?s=89ed8d7cf49b25ce49abdc519797bac0ba60233f&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'seventhChords8',
    sources: [
      'https://player.vimeo.com/external/414373830.m3u8?s=7e1aaeacb49fd7d517794551b570a76bc066a04b&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414373830.sd.mp4?s=9027fce4b45b2a21efe77bef08aab25ab015c11e&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'seventhChords9',
    sources: [
      'https://player.vimeo.com/external/414373866.m3u8?s=f19cd74dfc10c53e3dde3426755eda54495fa910&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414373866.sd.mp4?s=240115dd25ed332bbacff5051ab3176f45150d60&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'sharpMajorKeys10',
    sources: [
      'https://player.vimeo.com/external/414373905.m3u8?s=9c10354fd4fe027090b78f11b723e30df55973d0&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414373905.sd.mp4?s=d22429831749ac5bad200478f69d2fbe5fa31bf8&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'sharpMajorKeys1',
    sources: [
      'https://player.vimeo.com/external/414373943.m3u8?s=851b22062553b55c7cfd28e39c2a7cb7eb1a9c34&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414373943.sd.mp4?s=f2843ba5184433d1489004d7ebef6030148278c3&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'sharpMajorKeys2',
    sources: [
      'https://player.vimeo.com/external/414373983.m3u8?s=30874959572bcfc9f9fa26f6bb06b9ddfcedc11f&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414373983.sd.mp4?s=dde6d13d13398f3527efb0e55ac4b52d2d365b16&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'sharpMajorKeys3',
    sources: [
      'https://player.vimeo.com/external/414374018.m3u8?s=1b7e270bea113cabb213943994caab31ff635588&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414374018.sd.mp4?s=a04bd9e431d53e8f44274af734738992144b4e8c&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'sharpMajorKeys4',
    sources: [
      'https://player.vimeo.com/external/414374054.m3u8?s=bb9acf6798bb36182be4cfe331a835b1439a8d1e&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414374054.sd.mp4?s=292d485d6eae3e8ecc4773cdad1335ca0b3e9a8b&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'sharpMajorKeys5',
    sources: [
      'https://player.vimeo.com/external/414374089.m3u8?s=48cd4ca3870045cec685786f587e69206332b042&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414374089.sd.mp4?s=27f033ce682b496f707044395f2f967a239a8c98&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'sharpMajorKeys6',
    sources: [
      'https://player.vimeo.com/external/414374123.m3u8?s=78bd6b5fcd7ae8ca8ac4df1e1e3534e320ac90f7&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414374123.sd.mp4?s=632f0f217e615f265a242299036d57110fcb1f6a&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'sharpMajorKeys7',
    sources: [
      'https://player.vimeo.com/external/414374150.m3u8?s=01f7004d78c4adc67976777a81f3c30bb45db475&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414374150.sd.mp4?s=8e4932a13b72cd84a14cc6a746cd1fd01e4c297e&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'sharpMajorKeys8',
    sources: [
      'https://player.vimeo.com/external/414374175.m3u8?s=4a08f165be55afdf8790c608d0ed693b474448b1&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414374175.sd.mp4?s=947be4b431b0dac7de841a842d65825095e5bb14&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'sharpMajorKeys9',
    sources: [
      'https://player.vimeo.com/external/414374192.m3u8?s=bd5a46b5a5c873f4b06f29cec03d254b76b1a055&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414374192.sd.mp4?s=c7dad49b6d6db9617d7d14ace3a6b4ec3bb6b7e7&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'simple-sixteenth-patterns-video-1',
    sources: [
      'https://player.vimeo.com/external/414374233.m3u8?s=0a65edb52e25d43d01a1407623c14957a058ec87&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414374233.sd.mp4?s=0b204d9ec5381eab1413f3cf714df5ded09b01be&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'simple-sixteenth-patterns-video-2',
    sources: [
      'https://player.vimeo.com/external/414374255.m3u8?s=611a8b10be1b306f695ea7513b740362951ac4d0&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414374255.sd.mp4?s=081460ba1b18455546126d6a86e5c634158865f0&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'simple-sixteenth-patterns-video-3',
    sources: [
      'https://player.vimeo.com/external/414374281.m3u8?s=e3e7eb5197969394a7f111fd0114365e64c5cb56&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414374281.sd.mp4?s=f7d34e492f1ae03df8d5c47409e3de7950b164c2&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'simple-sixteenth-patterns-video-4',
    sources: [
      'https://player.vimeo.com/external/414374312.m3u8?s=06856b3d6cc0c1b3dd11334753055ef90d0f8de7&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414374312.sd.mp4?s=636fb9c77ebfa9209495971ddf3f842980a6a39c&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'simple-sixteenth-patterns-video-5',
    sources: [
      'https://player.vimeo.com/external/414374340.m3u8?s=80284a03f8b6e5e9e3b136c8c8b68e07a5d801f6&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414374340.sd.mp4?s=08d12d5cd7c2bd4632bdeaec29ef18fa6e85f29c&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'trebleClef1-1',
    sources: [
      'https://player.vimeo.com/external/414374369.m3u8?s=be1b336acafd0af15d5bfcc2720d7a865d876551&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414374369.sd.mp4?s=38ec3b28129bc39a1e0aba525ee1e3d2ecac938f&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'trebleClef1-2',
    sources: [
      'https://player.vimeo.com/external/414374404.m3u8?s=242ecfeab023596949f218fc189cadd9a1a20a5e&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414374404.sd.mp4?s=c5f169105099b884b23966a6dedab215e8ed420f&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'trebleClef1-3',
    sources: [
      'https://player.vimeo.com/external/414374434.m3u8?s=2365e4fb9ed6f06363656211c4969a3948d04c0d&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414374434.sd.mp4?s=ad9f6dd097f43930f4346848bd8b00d5c9b64ef8&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'trebleClef2-1',
    sources: [
      'https://player.vimeo.com/external/414374466.m3u8?s=eee8505b968fb4d2395b401c49911dfdf1d6fa58&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414374466.sd.mp4?s=81d6ad9bfb015396c285f0b3fa1bd530bdbd9abd&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'trebleClef2-2',
    sources: [
      'https://player.vimeo.com/external/414374488.m3u8?s=5e1ac4a224a5a16bd6c7e2c80c76c8b4999e003f&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414374488.sd.mp4?s=fb1fc8f43d607dc2351136b5e6fef9910f480266&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'trebleClef2-3',
    sources: [
      'https://player.vimeo.com/external/414583717.m3u8?s=66607c0165c85eeaa7453665f4def5c4a0df531a',
      'https://player.vimeo.com/external/414583717.sd.mp4?s=67e5da4c3f43560e7a797986269e291067d59002&profile_id=165',
    ],
  },
  {
    name: 'trebleClef3-1',
    sources: [
      'https://player.vimeo.com/external/414374549.m3u8?s=93cb0b9cb04c57406f725502d697a7f5a12db22e&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414374549.sd.mp4?s=2dce4e250b3e8b1b416c00fba21041d3b9dc1491&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'trebleClef3-2',
    sources: [
      'https://player.vimeo.com/external/414374574.m3u8?s=37a26888c83476121a4ed354d477264bd8bcdc77&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414374574.sd.mp4?s=8befd6c2245061a5710ec94054c11e489e6b66fd&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'triadSpacingInversion1',
    sources: [
      'https://player.vimeo.com/external/414374594.m3u8?s=f0a15a5842bbc8b6359ea7db55d1f7aa7d4252b3&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414374594.sd.mp4?s=b5f355451a7156a9fe7d1d7857fe653a9684fe9e&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'triadSpacingInversion2',
    sources: [
      'https://player.vimeo.com/external/414374613.m3u8?s=55daed5de9da446224e7b07caa35b7daa606d4d4&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414374613.sd.mp4?s=9a51f29683d6710d359fc4028925a81613905694&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'triadSpacingInversion3',
    sources: [
      'https://player.vimeo.com/external/414374642.m3u8?s=933f993c52ea7d06d06150d921e986f41f1b9952&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414374642.sd.mp4?s=daa2f6b46424ce8fca26bc3f54dc6bb3ecc5f51d&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'triadSpacingInversion4',
    sources: [
      'https://player.vimeo.com/external/414374675.m3u8?s=59d1f2b05c62f142f37ded86f2abf8d00cab770e&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414374675.sd.mp4?s=e44f6a28bf8cc32424bc7ebc2894ef8276698d38&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'triadSpacingInversion5',
    sources: [
      'https://player.vimeo.com/external/414374701.m3u8?s=35037dc3e7b1a65facdcc9f3b38ad9a0d68803d2&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414374701.sd.mp4?s=799c0808725a02df09449dd36fa89551f4d884c8&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'triadSpacingInversion6',
    sources: [
      'https://player.vimeo.com/external/414374727.m3u8?s=89d471ad636c9b733f0dc4d095dff6091ad755d6&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414374727.sd.mp4?s=38088a68c198f0df017bbd36f47cc91e97d1fe7e&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'triadSpacingInversion7',
    sources: [
      'https://player.vimeo.com/external/414374767.m3u8?s=9c2a4505ab981480a0fe99bb07479080de3ee914&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414374767.sd.mp4?s=b54e5a73c5084134059af6212b56c8432352d361&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'triadSpacingInversion8',
    sources: [
      'https://player.vimeo.com/external/414374797.m3u8?s=03f3e3a3f20dc7d4892897baab4c79411ce5e1e1&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414374797.sd.mp4?s=eb756e18ca8b149c62e121b77df0009fb87e6598&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'triads1',
    sources: [
      'https://player.vimeo.com/external/414374832.m3u8?s=2eb5dbd7d3b4fd05fb29aa70bfabea304a0917c7&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414374832.sd.mp4?s=2970d3189b759acf5c10241732e936cf878359aa&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'triads2',
    sources: [
      'https://player.vimeo.com/external/414374866.m3u8?s=71745a735f7092967ca146227ed19311e5edf1b7&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414374866.sd.mp4?s=a509bf16fe43a0d75d8b44f0ccfdc63aa1b17650&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'triads3',
    sources: [
      'https://player.vimeo.com/external/414374893.m3u8?s=7c2bdd7a59b181bf1169001aa6e2952ecc237e6e&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414374893.sd.mp4?s=4281c2faa1df22b9ef37d0e166cd46c8a5cf436d&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'triads4',
    sources: [
      'https://player.vimeo.com/external/414374921.m3u8?s=c41bd36a026c53a73cc8cb98941bc8cdbbaa3449&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414374921.sd.mp4?s=e83aa1f3993e9e27a7dfa9b8af26068398a34b7b&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'triads5',
    sources: [
      'https://player.vimeo.com/external/414374947.m3u8?s=85e119ceea2e79692b71cc09c119b1f1f201bff4&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414374947.sd.mp4?s=a661b6e039aeec4da14e2262dedad56fa0038448&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'triads6',
    sources: [
      'https://player.vimeo.com/external/414374969.m3u8?s=b777d313726b5bc939c5e1d4f47f6c98428ccbd7&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414374969.sd.mp4?s=d581a0f8fec529e9bfd4914219f18677da71b461&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'triads7',
    sources: [
      'https://player.vimeo.com/external/414375004.m3u8?s=ad1373e3ee4cc28b9416a516402a48fc70ea5cfc&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414375004.sd.mp4?s=812a5d84fc1675334bdebd12c6e8844bc8185305&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'trickyIntervals1',
    sources: [
      'https://player.vimeo.com/external/414375026.m3u8?s=9987db20cacb32e6c6e6ff3c025673088c84417e&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414375026.sd.mp4?s=b61d6fad4ebeaa972df8adfd420a4207c4bf2e6a&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'trickyIntervals2',
    sources: [
      'https://player.vimeo.com/external/414375058.m3u8?s=ce35ca48124e94bd2cd0be26fff586a89a27e468&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414375058.sd.mp4?s=5a37169d504cb782a79ce6ea7db4035114cad667&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'trickyIntervals3',
    sources: [
      'https://player.vimeo.com/external/414375087.m3u8?s=2b03029d5c3a50e3940474dd61136400243c3bcf&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414375087.sd.mp4?s=2c54d9432cb3a9063793134215fbacd4eac641f2&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'trickyIntervals4',
    sources: [
      'https://player.vimeo.com/external/414375112.m3u8?s=df7a15fa879322e495b9b151c783aa520412ca2f&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414375112.sd.mp4?s=a09d8beb1f6613ba9e6c122c525f289a921b9446&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'trickyIntervals5',
    sources: [
      'https://player.vimeo.com/external/414375142.m3u8?s=3c14accdb912fdbbd87a7d93a61e6370724d5e29&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414375142.sd.mp4?s=6d43aa06051fe71b279dd47ddbeac7bcaf4ef1b6&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'understandingNoteValues1american',
    sources: [
      'https://player.vimeo.com/external/414375164.m3u8?s=9cd0c11a55df24ba2c821a2906db95a3d693573c&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414375164.sd.mp4?s=952d904c90a007e641f76e4cf5ac1dc59397edd3&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'understandingNoteValues2american',
    sources: [
      'https://player.vimeo.com/external/414375188.m3u8?s=0fa1174f6d67b169cb8ca0fa886fc82f768192bb&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414375188.sd.mp4?s=21123f835006018b99137316ea8dd3f7bfafb5fa&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'understandingNoteValues3american',
    sources: [
      'https://player.vimeo.com/external/414375221.m3u8?s=de2a57d4e442d53e4ec2980b7426f255ea290414&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414375221.sd.mp4?s=1c1b2086800b8d95766dedb9dd8afceb1f23e6c9&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'understandingNoteValues4american',
    sources: [
      'https://player.vimeo.com/external/414375253.m3u8?s=854b1de197a8785598a869922db6a03f14a0a5a8&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414375253.sd.mp4?s=74286ae3df1294d3ec2e8bbd48755ad48b4f6049&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'understandingNoteValues5american',
    sources: [
      'https://player.vimeo.com/external/414375284.m3u8?s=868ea0310a4dfff8b9b5b496f3f4e3e9356097bd&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414375284.sd.mp4?s=7f0c7c37a34becaa561541d3891a1c99e442a5db&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'understandingNoteValues6american',
    sources: [
      'https://player.vimeo.com/external/414375307.m3u8?s=64e7f33edf2fc6c489a18f677587bd7841b7a874&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414375307.sd.mp4?s=14be600f9d55232317129bf4ee426e62e12981bd&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'understandingTimeSignatures1american',
    sources: [
      'https://player.vimeo.com/external/414375342.m3u8?s=91e32c6b4bb7ef8de449c17b4e6c47142a747bf2&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414375342.sd.mp4?s=99616f403e7739d701f63177d342998b9a28f2cf&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'understandingTimeSignatures2american',
    sources: [
      'https://player.vimeo.com/external/414375373.m3u8?s=00bfd7c46b988ddf617157fb3c95316a7fc4f8a8&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414375373.sd.mp4?s=b716fa5974a5bb5a20aab1b3cc6cd70dc54da161&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'understandingTimeSignatures3american',
    sources: [
      'https://player.vimeo.com/external/414375408.m3u8?s=9378ab7f1ac41c0253bcb4998f16589a4151ead8&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414375408.sd.mp4?s=398d1960fa5f2f70943ad0a4c9945b9a10e9981a&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'understandingTimeSignatures4american',
    sources: [
      'https://player.vimeo.com/external/414375437.m3u8?s=2523d6d8d0c4907b88fdb8aa30f9a9b9379a602c&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414375437.sd.mp4?s=08d32553334aa7cafefea90eea99f28789a6b84a&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'videoTK',
    sources: [
      'https://player.vimeo.com/external/414375852.m3u8?s=7df6de039589d7ababcf51ba39f51f3bcb4566bf&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414375852.sd.mp4?s=daa06ce83e605305795c835520630ca518653086&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'writingHalfSteps1',
    sources: [
      'https://player.vimeo.com/external/414375899.m3u8?s=3106b08ef879d73e4315c2bd78f3e07955e4ba17&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414375899.sd.mp4?s=af215e31f68674056e7eb5c8eaabbd30e7a88db4&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'writingHalfSteps2',
    sources: [
      'https://player.vimeo.com/external/414375953.m3u8?s=a41b066383a6d0707694e46e31e1b9d1f0479587&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414375953.sd.mp4?s=b0b544c81a20d38ed0ad1d7566a597c78744dd9a&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'writingHalfSteps3',
    sources: [
      'https://player.vimeo.com/external/414376007.m3u8?s=93bf400c22d3083f491fb0e1dd45a19cc789c1e3&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414376007.sd.mp4?s=bdacfdeb734cad3d6cf212607cbd5608ceea0621&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'writingHalfSteps4',
    sources: [
      'https://player.vimeo.com/external/414376056.m3u8?s=7968c201bd51df5e48a843d98ca243e7f798bd2a&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414376056.sd.mp4?s=421183ff7b3e67f88abefc65d1a01e49ff983f9b&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'writingMajorScales1',
    sources: [
      'https://player.vimeo.com/external/414376112.m3u8?s=12929281daf214781503a2466202dc8324c6a186&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414376112.sd.mp4?s=4f75e5e3dbca624887ac1ef0e3839ae34aa763cc&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'writingMajorScales2',
    sources: [
      'https://player.vimeo.com/external/414376170.m3u8?s=d3b29954ff0d397f9c98619d88279b265974bef0&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414376170.sd.mp4?s=0f7ad1d81f550f126a7f1f9553c67a2b89ad2352&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'writingMajorScales3',
    sources: [
      'https://player.vimeo.com/external/414376205.m3u8?s=0e552638f949b7696e4c39a22d045332faf1bd6b&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414376205.sd.mp4?s=d3a7c3b6f2ad3679d5e6701ee2da0b9c769d52ef&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'writingWholeSteps1',
    sources: [
      'https://player.vimeo.com/external/414376265.m3u8?s=64548fefe08cb1d5eddb9c29bc33420ba43399d4&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414376265.sd.mp4?s=a813b4d87c60d29f2d6bb3f00ac0560f54c8bf36&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'writingWholeSteps2',
    sources: [
      'https://player.vimeo.com/external/414376304.m3u8?s=fffd0eb3882e8107986b8ce78de8d4e48d597233&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414376304.sd.mp4?s=9497d79e1cb038b2f2b447f73f812abd5a4c22c3&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'writingWholeSteps3',
    sources: [
      'https://player.vimeo.com/external/414376346.m3u8?s=b7545ab1a768c2659bde62b03b603f60c6e70c5d&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414376346.sd.mp4?s=e7ba7727a9fea95e74a31470a35e09522886b1a3&profile_id=164&oauth2_token_id=1334832536',
    ],
  },
  {
    name: 'writingWholeSteps4',
    sources: [
      'https://player.vimeo.com/external/414376406.m3u8?s=c6f201bdf0e58c25f40c55b0b272ade1fbdc562d&oauth2_token_id=1334832536',
      'https://player.vimeo.com/external/414376406.sd.mp4?s=9bac08ed11fa38a5aab6cb0651e8a9ccabf7141a&profile_id=164&oauth2_token_id=1334832536',
    ],
  },

  {
    name: 'et_major_scale_scale_degrees_and_solfege',
    sources: [
      'https://player.vimeo.com/external/585433242.m3u8?s=2db34554528a25bfd1417a981072d80f479ed095',
      'https://player.vimeo.com/external/585433242.sd.mp4?s=d3b37236da8fa39f99285d83d3f9852ccefad1f6&profile_id=165',
    ],
  },
  {
    name: 'et_major_scale_hand_signs',
    sources: [
      'https://player.vimeo.com/external/585441461.m3u8?s=9977a7503931b7284ff6c70b60f8a6b64dc1413e',
      'https://player.vimeo.com/external/585441461.sd.mp4?s=de760fefb2d0a929e377b16b9bf98bbfbba6fe2c&profile_id=165',
    ],
  },
  {
    name: 'et_major_scale_half_and_whole_steps_scaleDegrees',
    sources: [
      'https://player.vimeo.com/external/585447646.m3u8?s=06b7503ca15c24b1a37e2cbfae47d35e5e43ec15',
      'https://player.vimeo.com/external/585447646.sd.mp4?s=f307cfb7c54a374db82c84958276b4554ea47dae&profile_id=165',
    ],
  },
  {
    name: 'et_major_scale_half_and_whole_steps_solfege',
    sources: [
      'https://player.vimeo.com/external/585438036.m3u8?s=0767dfa141f19234bf34f3d651a57ce4072559c4',
      'https://player.vimeo.com/external/585438036.sd.mp4?s=fe7e2b95fcc4009ab1c782941a77fb9d17a8fc6e&profile_id=165',
    ],
  },
  {
    name: 'et_major_scale_hearing_half_and_whole_steps_scaleDegrees',
    sources: [
      'https://player.vimeo.com/external/597159055.m3u8?s=6b1b7dd47c5c43c48896abc17cba278cc1afe13b',
      'https://player.vimeo.com/external/597159055.sd.mp4?s=2091a6f199ec44abc7ce64e78757246e5522ea34&profile_id=165',
    ],
  },
  {
    name: 'et_major_scale_hearing_half_and_whole_steps_solfege',
    sources: [
      'https://player.vimeo.com/external/585512687.m3u8?s=f873e9cd28e5abc3d3123451a06ce79fed450dae',
      'https://player.vimeo.com/external/585512687.sd.mp4?s=8fee1c8636d78bde2b857fa65b6cedbbabb9a279&profile_id=164',
      'https://player.vimeo.com/progressive_redirect/playback/585512687/rendition/720p/file.mp4?loc=external&signature=72eb847d6344eea80b8742a52e89eff0b3f9db2a1cb865d14a020a0a478cd24b',
    ],
  },
  {
    name: 'et_major_scale_three_note_patterns_scaleDegrees',
    sources: [
      'https://player.vimeo.com/external/597157149.m3u8?s=08bea2a9202a5f920e40313bc5dc5e57e9f57c49',
      'https://player.vimeo.com/external/597157149.sd.mp4?s=d99d3399b5329a0ee2d7d2cb10ba37d3e362aed8&profile_id=165',
    ],
  },
  {
    name: 'et_major_scale_three_note_patterns_solfege',
    sources: [
      'https://player.vimeo.com/external/597155402.m3u8?s=3b4b9125cb3d27d22bf23cd561d5a23d0d03eb94',
      'https://player.vimeo.com/external/597155402.sd.mp4?s=d045d799e771e5f96ac4b134e75ec9b084b5b0f1&profile_id=165',
    ],
  },
  {
    name: 'et_major_scale_tonic_scaleDegrees',
    sources: [
      'https://player.vimeo.com/external/597242688.m3u8?s=e810a6e8f936397e023d5de171a2eaf2368db746',
      'https://player.vimeo.com/external/597242688.sd.mp4?s=f66bf027ebf8600aa148329c024af3dc50ef016c&profile_id=165',
    ],
  },
  {
    name: 'et_major_scale_tonic_solfege',
    sources: [
      'https://player.vimeo.com/external/597151006.m3u8?s=53deb9df351c096b81465e328ffc1a00803ed14a',
      'https://player.vimeo.com/external/597151006.sd.mp4?s=a5b0fd010eea6c84e900f24a3b4780af3e95ffbd&profile_id=165',
    ],
  },
  {
    name: 'solfege_and_the_staff_sharp-keys-solfege',
    sources: [
      'https://player.vimeo.com/external/605977440.m3u8?s=96e6c359586a9ae245599aabea465dd18cbde6cb',
      'https://player.vimeo.com/external/605977440.sd.mp4?s=05222338d99a9e2fadbfbe12605ee7d9d632151a&profile_id=165',
    ],
  },
  {
    name: 'solfege_and_the_staff_sharp-keys-scaleDegrees',
    sources: [
      'https://player.vimeo.com/external/605981017.m3u8?s=45fd434afbefd235d0b3801f6b88cbe69c37eb15',
      'https://player.vimeo.com/external/605981017.sd.mp4?s=81b468d398680ef46c6ba6518ef9599906bda799&profile_id=165',
    ],
  },

  {
    name: 'solfege_and_the_staff_flat-keys-solfege',
    sources: [
      'https://player.vimeo.com/external/605993277.m3u8?s=db9e1f348fe1ace319bad1381ca19163c8d6737e',
      'https://player.vimeo.com/external/605993277.sd.mp4?s=a2cde679ba6814e10683d066fa343946ce58cae0&profile_id=165',
    ],
  },
  {
    name: 'solfege_and_the_staff_flat-keys-scaleDegrees',
    sources: [
      'https://player.vimeo.com/external/605995902.m3u8?s=3e595665f7d25ab1d32b16979e641c2cd9f1d18e',
      'https://player.vimeo.com/external/605995902.sd.mp4?s=18e670ad2e5cf0402dcd5ff17ddc3259a194484e&profile_id=165',
    ],
  },

  {
    name: 'solfege_and_the_staff_all-keys-solfege',
    sources: [
      'https://player.vimeo.com/external/605999340.m3u8?s=56e92ab7398fe71a1526c7e786c7067049ee0250',
      'https://player.vimeo.com/external/605999340.sd.mp4?s=545e6a726843c690ccb44faf4b3584a7f4e171fb&profile_id=164',
    ],
  },
  {
    name: 'solfege_and_the_staff_all-keys-scaleDegrees',
    sources: [
      'https://player.vimeo.com/external/606000240.m3u8?s=4b779e44624b67b2caaaf286964bd8328b7f164c',
      'https://player.vimeo.com/external/606000240.sd.mp4?s=3006334e26b2f8f9aafba2e45fb397cb50d896b4&profile_id=164',
    ],
  },

  {
    name: 'solfege_and_the_staff_scale-solfege',
    sources: [
      'https://player.vimeo.com/external/605985623.m3u8?s=30531f83596bc5eddc87b568ca5e5799921168eb',
      'https://player.vimeo.com/external/605985623.sd.mp4?s=c18ff08a852416fe37222cf55b3ae058fd66677c&profile_id=164',
    ],
  },
  {
    name: 'solfege_and_the_staff_scale-scaleDegrees',
    sources: [
      'https://player.vimeo.com/external/605988009.m3u8?s=e5ee94c9f390ec0d8be9b86e609d5a920d7ad3d7',
      'https://player.vimeo.com/external/605988009.sd.mp4?s=6da37f9385ed3f1b3baf9c48d457cfd875e68355&profile_id=165',
    ],
  },

  {
    name: 'solfege_and_the_staff_notes-from-scale-degrees-solfege',
    sources: [
      'https://player.vimeo.com/external/605989891.m3u8?s=c78625774c30e2ecea31f8e3802bee2d2ba69e4b',
      'https://player.vimeo.com/external/605989891.sd.mp4?s=61538c1c75b0856e529f48421d6b6ed085789526&profile_id=164',
    ],
  },
  {
    name: 'solfege_and_the_staff_notes-from-scale-degrees-scaleDegrees',
    sources: [
      'https://player.vimeo.com/external/605991644.m3u8?s=507152f892650fde47c4f91b9d5f90ad5551c30c',
      'https://player.vimeo.com/external/605991644.sd.mp4?s=fd025a2a35acd0d7e3a33e8561cdaabe1b417de1&profile_id=165',
    ],
  },

  {
    name: 'solfege_and_the_staff_staff-to-scale-degrees-solfege',
    sources: [
      'https://player.vimeo.com/external/605970055.m3u8?s=377740c00523ea2b33551f1733646957baafa78a',
      'https://player.vimeo.com/external/605970055.sd.mp4?s=b88f98b71d159fe12872db04fc8a447a98b4a3a6&profile_id=165',
    ],
  },
  {
    name: 'solfege_and_the_staff_staff-to-scale-degrees-scaleDegrees',
    sources: [
      'https://player.vimeo.com/external/605970989.m3u8?s=bb7ab903c9af933af093e3b278c5449bd3581d6b',
      'https://player.vimeo.com/external/605970989.sd.mp4?s=06ee10001022c42829da3dd8565ed3f561127adb&profile_id=165',
    ],
  },

  {
    name: 'solfege_and_the_staff_stepwise-dictation-solfege',
    sources: [
      'https://player.vimeo.com/external/605968405.m3u8?s=ab8c9457ad9d677657ebaa02157778288796fe74',
      'https://player.vimeo.com/external/605968405.sd.mp4?s=72de2d82d67a41e5480a8b6bfcd1c74610426761&profile_id=165',
    ],
  },
  {
    name: 'solfege_and_the_staff_stepwise-dictation-scaleDegrees',
    sources: [
      'https://player.vimeo.com/external/605967116.m3u8?s=447ad7103f5d75ba566ed97c81a6ac8a0f638c49',
      'https://player.vimeo.com/external/605967116.sd.mp4?s=e542e105ff8f5d4295efb1b5b156a29dd8879dab&profile_id=165',
    ],
  },

  {
    name: 'solfege_and_the_staff_conclusion-solfege',
    sources: [
      'https://player.vimeo.com/external/605998365.m3u8?s=99b556b313004b7f02f20cc53b773549bc646f6d',
      'https://player.vimeo.com/external/605998365.sd.mp4?s=1ea05c2ece6ea55dffa17df561f51632732c274a&profile_id=165',
    ],
  },
  {
    name: 'solfege_and_the_staff_conclusion-scaleDegrees',
    sources: [
      'https://player.vimeo.com/external/605998917.m3u8?s=51a15f4b5e3c0be2f35f66f61a2eaef09d3df285',
      'https://player.vimeo.com/external/605998917.sd.mp4?s=d6dbb3da30dde5356c0d7aa0a264f28b6a4c128d&profile_id=165',
    ],
  },
  {
    name: 'octave_numbers_middle_c',
    sources: [
      'https://player.vimeo.com/external/645618574.m3u8?s=9b046e75266373c0adfa57dccbe027d2067551d5',
      'https://player.vimeo.com/external/645618574.sd.mp4?s=e8aa7c4df6da802df209a93e85a1043b520ed373&profile_id=165',
    ],
  },
  {
    name: 'octave_numbers_c_octaves',
    sources: [
      'https://player.vimeo.com/external/645616046.m3u8?s=c28f6f0531874248647da440e840ef1de569e58b',
      'https://player.vimeo.com/external/645616046.sd.mp4?s=f03a8814dda03dd860470c5aae098f473a1a34ff&profile_id=165',
    ],
  },
  {
    name: 'octave_numbers_all_notes',
    sources: [
      'https://player.vimeo.com/external/645614858.m3u8?s=4c928fb9c16cf29d3216de3e006c24aaaa1d9bb1',
      'https://player.vimeo.com/external/645614858.sd.mp4?s=95c033d4152009c79ff5d90947ad8ed5f15653d2&profile_id=165',
    ],
  },
  {
    name: 'octave_numbers_accidentals',
    sources: [
      'https://player.vimeo.com/external/645613263.m3u8?s=bd37bdc7c65c5a039d82fc50e875c27640ab057a',
      'https://player.vimeo.com/external/645613263.sd.mp4?s=52b78bf7883b1074f9c5c5e8058c22c1941fecfe&profile_id=165',
    ],
  },
  {
    name: 'octave_numbers_summary',
    sources: [
      'https://player.vimeo.com/external/645616991.m3u8?s=d05bbdf540ba38b22f32193cf7fb2a1333bdbfa4',
      'https://player.vimeo.com/external/645616991.sd.mp4?s=23b559baea501a7827b0adc0d49ef20e48d835fa&profile_id=165',
    ],
  },
];
